import {
    ColumnsSettingsViewDict,
    CommonSettingEditor
} from '../typings/common';
import { GoalDecl } from '../typings/goals';

export const OPEN_COLUMNS_SETTINGS_EDITOR = 'OPEN_COLUMNS_SETTINGS_EDITOR';
export type OPEN_COLUMNS_SETTINGS_EDITOR = typeof OPEN_COLUMNS_SETTINGS_EDITOR;

export interface OpenColumnsSettingsEditor {
    type: OPEN_COLUMNS_SETTINGS_EDITOR;
    view: string;
    columnsSettings: ColumnsSettingsViewDict;
    commonSettings: CommonSettingEditor;
    goalsSettings?: GoalDecl[];
}

export function openColumnsSettingEditor(
    view: string,
    columnsSettings: ColumnsSettingsViewDict,
    commonSettings: CommonSettingEditor,
    goalsSettings?: GoalDecl[]
): OpenColumnsSettingsEditor {
    return {
        type: OPEN_COLUMNS_SETTINGS_EDITOR,
        view,
        columnsSettings,
        commonSettings,
        goalsSettings
    };
}

export const CLOSE_COLUMNS_SETTINGS_EDITOR = 'CLOSE_COLUMNS_SETTINGS_EDITOR';
export type CLOSE_COLUMNS_SETTINGS_EDITOR = typeof CLOSE_COLUMNS_SETTINGS_EDITOR;

export interface CloseColumnsSettingsEditor {
    type: CLOSE_COLUMNS_SETTINGS_EDITOR;
}

export function closeColumnsSettingEditor(): CloseColumnsSettingsEditor {
    return {
        type: CLOSE_COLUMNS_SETTINGS_EDITOR
    };
}

export const SELECT_MENU_ITEM_COLUMNS_SETTINGS_EDITOR =
    'SELECT_MENU_ITEM_COLUMNS_SETTINGS_EDITOR';
export type SELECT_MENU_ITEM_COLUMNS_SETTINGS_EDITOR = typeof SELECT_MENU_ITEM_COLUMNS_SETTINGS_EDITOR;

export interface SelectMenuItemColumnsSettingsEditor {
    type: SELECT_MENU_ITEM_COLUMNS_SETTINGS_EDITOR;
    value: string;
}

export function selectMenuItemColumnsSettingsEditor(
    value: string
): SelectMenuItemColumnsSettingsEditor {
    return {
        type: SELECT_MENU_ITEM_COLUMNS_SETTINGS_EDITOR,
        value
    };
}

export const CHANGE_COLUMNS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR =
    'CHANGE_COLUMNS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR';
export type CHANGE_COLUMNS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR = typeof CHANGE_COLUMNS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR;

export interface ChangeColumnsOrderFromColumnsSettingsEditor {
    type: CHANGE_COLUMNS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR;
    view: string;
    listKeys: string[];
}

export function changeColumnsOrderFromColumnsSettingsEditor(
    view: string,
    listKeys: string[]
): ChangeColumnsOrderFromColumnsSettingsEditor {
    return {
        type: CHANGE_COLUMNS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR,
        view,
        listKeys
    };
}

export const CHANGE_COLUMNS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR =
    'CHANGE_COLUMNS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR';
export type CHANGE_COLUMNS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR = typeof CHANGE_COLUMNS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR;

export interface ChangeColumnsCheckedFromColumnsSettingsEditor {
    type: CHANGE_COLUMNS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR;
    view: string;
    listKeys: string[];
}

export function changeColumnsCheckedFromColumnsSettingsEditor(
    view: string,
    listKeys: string[]
): ChangeColumnsCheckedFromColumnsSettingsEditor {
    return {
        type: CHANGE_COLUMNS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR,
        view,
        listKeys
    };
}

export const TOGGLE_SHOW_TOTAL_SETTINGS_EDITOR =
    'TOGGLE_SHOW_TOTAL_SETTINGS_EDITOR';
export type TOGGLE_SHOW_TOTAL_SETTINGS_EDITOR = typeof TOGGLE_SHOW_TOTAL_SETTINGS_EDITOR;

export interface ToggleShowTotalSettingsEditor {
    type: TOGGLE_SHOW_TOTAL_SETTINGS_EDITOR;
}

export function toggleShowTotalSettingsEditor(): ToggleShowTotalSettingsEditor {
    return {
        type: TOGGLE_SHOW_TOTAL_SETTINGS_EDITOR
    };
}

export const TOGGLE_COMPACT_VIEW_SETTINGS_EDITOR =
    'TOGGLE_COMPACT_VIEW_SETTINGS_EDITOR';
export type TOGGLE_COMPACT_VIEW_SETTINGS_EDITOR = typeof TOGGLE_COMPACT_VIEW_SETTINGS_EDITOR;

export interface ToggleCompactViewSettingsEditor {
    type: TOGGLE_COMPACT_VIEW_SETTINGS_EDITOR;
}

export function toggleCompactViewSettingsEditor(): ToggleCompactViewSettingsEditor {
    return {
        type: TOGGLE_COMPACT_VIEW_SETTINGS_EDITOR
    };
}

export const TOGGLE_ONLY_FAVORITE_SETTINGS_EDITOR =
    'TOGGLE_ONLY_FAVORITE_SETTINGS_EDITOR';
export type TOGGLE_ONLY_FAVORITE_SETTINGS_EDITOR = typeof TOGGLE_ONLY_FAVORITE_SETTINGS_EDITOR;

export interface ToggleOnlyFavoriteSettingsEditor {
    type: TOGGLE_ONLY_FAVORITE_SETTINGS_EDITOR;
}

export function toggleOnlyFavoriteSettingsEditor(): ToggleOnlyFavoriteSettingsEditor {
    return {
        type: TOGGLE_ONLY_FAVORITE_SETTINGS_EDITOR
    };
}

export const SAVE_COLUMNS_SETTINGS_EDITOR = 'SAVE_COLUMNS_SETTINGS_EDITOR';
export type SAVE_COLUMNS_SETTINGS_EDITOR = typeof SAVE_COLUMNS_SETTINGS_EDITOR;

export interface SaveColumnsSettingsEditor {
    type: SAVE_COLUMNS_SETTINGS_EDITOR;
    view: string;
}

export function saveColumnsSettingsEditor(
    view: string
): SaveColumnsSettingsEditor {
    return {
        type: SAVE_COLUMNS_SETTINGS_EDITOR,
        view
    };
}

export const CHANGE_GOALS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR =
    'CHANGE_GOALS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR';
export type CHANGE_GOALS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR = typeof CHANGE_GOALS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR;

export interface ChangeGoalsOrderFromColumnsSettingsEditor {
    type: CHANGE_GOALS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR;
    listKeys: string[];
}

export function changeGoalsOrderFromColumnsSettingsEditor(
    listKeys: string[]
): ChangeGoalsOrderFromColumnsSettingsEditor {
    return {
        type: CHANGE_GOALS_ORDER_FROM_COLUMNS_SETTINGS_EDITOR,
        listKeys
    };
}

export const CHANGE_GOALS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR =
    'CHANGE_GOALS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR';
export type CHANGE_GOALS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR = typeof CHANGE_GOALS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR;

export interface ChangeGoalsCheckedFromColumnsSettingsEditor {
    type: CHANGE_GOALS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR;
    listKeys: string[];
}

export function changeGoalsCheckedFromColumnsSettingsEditor(
    listKeys: string[]
): ChangeGoalsCheckedFromColumnsSettingsEditor {
    return {
        type: CHANGE_GOALS_CHECKED_FROM_COLUMNS_SETTINGS_EDITOR,
        listKeys
    };
}

export const UPDATE_GOALS_SETTINGS_COLUMNS_SETTINGS_EDITOR =
    'UPDATE_GOALS_SETTINGS_COLUMNS_SETTINGS_EDITOR';
export type UPDATE_GOALS_SETTINGS_COLUMNS_SETTINGS_EDITOR = typeof UPDATE_GOALS_SETTINGS_COLUMNS_SETTINGS_EDITOR;

export interface UpdateGoalsSettingsColumnsSettingsEditor {
    type: UPDATE_GOALS_SETTINGS_COLUMNS_SETTINGS_EDITOR;
    goalsSettings: GoalDecl[];
}

export function updateGoalsSettingsColumnsSettingsEditor(
    goalsSettings: GoalDecl[]
): UpdateGoalsSettingsColumnsSettingsEditor {
    return {
        type: UPDATE_GOALS_SETTINGS_COLUMNS_SETTINGS_EDITOR,
        goalsSettings
    };
}

export type ColumnsSettingsEditorAction =
    | OpenColumnsSettingsEditor
    | CloseColumnsSettingsEditor
    | SelectMenuItemColumnsSettingsEditor
    | ChangeColumnsOrderFromColumnsSettingsEditor
    | ChangeColumnsCheckedFromColumnsSettingsEditor
    | SaveColumnsSettingsEditor
    | ToggleShowTotalSettingsEditor
    | ToggleCompactViewSettingsEditor
    | ToggleOnlyFavoriteSettingsEditor
    | ChangeGoalsCheckedFromColumnsSettingsEditor
    | ChangeGoalsOrderFromColumnsSettingsEditor
    | UpdateGoalsSettingsColumnsSettingsEditor;
